import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff846c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ag-nav nav flex-column",
  id: "agsc-nav"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["id"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "nav-link d-flex align-items-center disabled-link",
  href: "#"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-link d-flex align-items-center disabled-link",
  href: "#"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_role = _resolveDirective("role")!
  const _directive_rule = _resolveDirective("rule")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (navItem, key) => {
      return _withDirectives((_openBlock(), _createElementBlock("li", {
        key: key,
        class: _normalizeClass([{
        'd-none':
          navItem.link == 'dashboard' && _ctx.loggedInUser.role == _ctx.Roles.AGMSAdmin,
      }, "nav-item"])
      }, [
        (navItem.type !== 'collapse')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: navItem.link,
              class: _normalizeClass(["nav-link d-flex align-items-center", 
          _ctx.$route.matched[1].name === navItem.name
            ? 'router-link-active router-link-exact-active'
            : ''
        ]),
              "aria-current": "page",
              onClickPassive: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu($event)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["ag-icon mr-3", 'ag-icon_' + navItem.icon])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.t(navItem.title)), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: _normalizeClass(["nav-link d-flex align-items-center flex-wrap", 
          _ctx.$route.matched[1].name === navItem.title
            ? 'router-link-active router-link-exact-active'
            : ''
        ]),
              "data-toggle": "collapse",
              href: '#collapsenav' + key,
              to: _ctx.createMasterUrl(navItem),
              role: "button",
              "aria-controls": 'collapsenav' + key
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["ag-icon mr-3", 'ag-icon_' + navItem.icon])
                }, null, 2),
                (navItem.title === 'administration')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      (_ctx.loggedInUser.role === _ctx.Roles.AGMSAdmin)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t("globalmanagement")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t(navItem.title)), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.t(navItem.title)), 1))
              ]),
              _: 2
            }, 1032, ["href", "to", "aria-controls", "class"])),
        (navItem.children)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 2,
              class: "collapse ag-nav nav ag-nav_child",
              id: 'collapsenav' + key,
              "data-parent": "#agsc-nav"
            }, [
              (navItem.title !== 'administration')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(navItem.children.filter(
              (f) =>
                (f.rules &&
                  f.rules.includes(_ctx.Rules.AGMSGroupSelect) &&
                  _ctx.agmsGroup.mainid) ||
                (f.rules &&
                  f.rules.includes(_ctx.Rules.AGMSTemplateSelect) &&
                  _ctx.agmsTemplate.mainid &&
                  _ctx.agmsTemplate.templateType != 2) ||
                (f.rules &&
                  f.rules.includes(_ctx.Rules.AGMSTemplateSelect) &&
                  f.rules.includes(_ctx.Rules.AGMSTemplateType2Select) &&
                  _ctx.agmsTemplate.mainid &&
                  _ctx.agmsTemplate.templateType == 2) ||
                !f.rules
            ), (childrenItem, childkey) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                      key: childkey,
                      class: _normalizeClass(["nav-item w-100", childrenItem.class])
                    }, [
                      _createVNode(_component_router_link, {
                        to: '/' + navItem.link + '/' + childrenItem.link,
                        class: _normalizeClass(
                _ctx.$route.path.split('/').length > 1 &&
                _ctx.$route.path.split('/')[2] == childrenItem.subParent
                  ? 'nav-link d-flex align-items-center router-link-exact-active'
                  : 'nav-link d-flex align-items-center'
              ),
                        "aria-current": "page",
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reloadCurrentPath($event)))
                      }, {
                        default: _withCtx(() => [
                          (childrenItem.title !== 'companyOverview')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t(childrenItem.title)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t("agmsCompanyOverview")), 1)
                                ])), [
                                  [_directive_role, [_ctx.Roles.AGMSAdmin]]
                                ]),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t("partnerOverview")), 1)
                                ])), [
                                  [_directive_role, [_ctx.Roles.PartnerAdmin]]
                                ]),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t("companyOverview")), 1)
                                ])), [
                                  [_directive_role, [_ctx.Roles.CompanyAdmin]]
                                ]),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t("siteCompanyOverview")), 1)
                                ])), [
                                  [_directive_role, [_ctx.Roles.SiteAdmin, _ctx.Roles.SiteAudit]]
                                ]),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t("groupCompanyOverview")), 1)
                                ])), [
                                  [_directive_role, [_ctx.Roles.GroupAdmin, _ctx.Roles.GroupAudit]]
                                ])
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["to", "class"])
                    ], 2)), [
                      [_directive_role, childrenItem.roles]
                    ])
                  }), 128))
                : _createCommentVNode("", true),
              (
            ([_ctx.Roles.AGMSAdmin, _ctx.Roles.PartnerAdmin, _ctx.Roles.CompanyAdmin].includes(
              _ctx.loggedInUser.role
            ) &&
              navItem.title === 'administration' &&
              !_ctx.agmsSite.mainid &&
              !_ctx.agmsGroup.mainid) ||
            (navItem.title === 'administration' &&
              [_ctx.Roles.GroupAdmin, _ctx.Roles.SiteAdmin].includes(_ctx.loggedInUser.role))
          )
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(navItem.children.filter(
              (f) =>
                (f.rules &&
                  f.rules.includes(_ctx.Rules.AGMSGroupSelect) &&
                  _ctx.agmsGroup.mainid) ||
                (f.rules &&
                  f.rules.includes(_ctx.Rules.AGMSTemplateSelect) &&
                  _ctx.agmsTemplate.mainid) ||
                !f.rules
            ), (childrenItem, childkey) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                      key: childkey,
                      class: _normalizeClass(["nav-item w-100", childrenItem.class])
                    }, [
                      (!childrenItem.disabled)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: '/' + navItem.link + '/' + childrenItem.link,
                            class: "nav-link d-flex align-items-center",
                            "aria-current": "page",
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reloadCurrentPath($event)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t(childrenItem.title)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (childrenItem.disabled)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_9, _toDisplayString(_ctx.t(childrenItem.title)), 1))
                        : _createCommentVNode("", true)
                    ], 2)), [
                      [_directive_role, childrenItem.roles]
                    ])
                  }), 128))
                : _createCommentVNode("", true),
              (navItem.title === 'administration' && _ctx.agmsSite.mainid)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(navItem.siteChildren, (childrenItem, childkey) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                      key: childkey,
                      class: _normalizeClass(["nav-item w-100", childrenItem.class])
                    }, [
                      (!childrenItem.disabled)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: '/' + navItem.link + '/' + childrenItem.link,
                            class: "nav-link d-flex align-items-center",
                            "aria-current": "page",
                            href: "#",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reloadCurrentPath($event)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t(childrenItem.title)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (childrenItem.disabled)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_10, _toDisplayString(_ctx.t(childrenItem.title)), 1))
                        : _createCommentVNode("", true)
                    ], 2)), [
                      [_directive_role, childrenItem.roles]
                    ])
                  }), 128))
                : _createCommentVNode("", true),
              (navItem.title === 'administration' && _ctx.agmsGroup.mainid)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(navItem.groupChildren, (childrenItem, childkey) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                      key: childkey,
                      class: _normalizeClass(["nav-item w-100", childrenItem.class])
                    }, [
                      _createVNode(_component_router_link, {
                        to: '/' + navItem.link + '/' + childrenItem.link,
                        class: "nav-link d-flex align-items-center",
                        "aria-current": "page",
                        href: "#",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reloadCurrentPath($event)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t(childrenItem.title)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 2)), [
                      [_directive_role, childrenItem.roles]
                    ])
                  }), 128))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ], 2)), [
        [_directive_role, navItem.roles],
        [_directive_rule, navItem.rules]
      ])
    }), 128))
  ]))
}